import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';
import { Button as ButtonComponent } from 'src/components/button';
import { Column } from '@prisjakt/ui/list/variants';
import { Hideable } from '@prisjakt/ui/hideable';
import { H3Text } from '@prisjakt/ui/text/variants';
import { OutlinedButton, PrimaryButton } from '@prisjakt/ui/button/variants';

export const ChangelogWrapper = styled.div``;

const alternateModalPosition = css`
  left: 100%;
  bottom: 0;
`;

export const ChangelogModal = styled(Hideable)`
  position: absolute;
  background: ${p => p.theme.bg.primary};
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  width: 320px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${alternateModalPosition};
`;

export const Main = styled(Column)`
  padding: ${layout.measurements.spacing100};
`;

export const Item = styled.div``;

export const Button = styled(ButtonComponent)`
  width: 100%;
`;

export const H3 = styled(H3Text)`
  margin: 0;
`;

export const ButtonWrapper = styled(PrimaryButton)`
  margin-top: 1rem;
  min-width: 160px;
  max-width: fit-content;
  text-align: center;

  ${media.mediumDown`
    max-width: 100%;
    width: auto;
  `}
`;

export const ReadMoreButton = styled(PrimaryButton)`
  width: 100%;
  text-align: center;
`;

export const ReadAllButton = styled(OutlinedButton)`
  width: 100%;
  text-align: center;
`;
